<script setup lang="ts">
import MarketingFlowTemplate from '@/views/autopilot/Components/MarketingFlowTemplate.vue'

import useTemplates from '@/views/autopilot/composables/templates'

const { t } = useI18n()
const router = useRouter()

const { templates, categories } = useTemplates()

const selectedCategory = ref<string>('all')

const filteredTemplates = computed(() => {
  if (selectedCategory.value === 'all') return templates.value
  if (selectedCategory.value === 'recommended') return templates.value.filter((template) => template.isRecommended)

  return templates.value.filter((template) => template.category === selectedCategory.value)
})

const goToCreateMarketingFlow = () => router.push({ name: 'MarketingFlowCreate' })

const selectCategory = (categoryId: string) => {
  selectedCategory.value = categoryId
}
</script>

<template>
  <div>
    <TheDetailHeader
      :title="t('pages.autopilot.autopilotsPage.templates.page.title')"
      :parent="{ label: t('pages.autopilot.autopilotsPage.title'), to: { name: 'AutopilotList' } }"
    >
      <template #actions>
        <Button variant="default-primary" @click="goToCreateMarketingFlow">
          {{ t('pages.autopilot.autopilotsPage.templates.page.button') }}
        </Button>
      </template>
    </TheDetailHeader>

    <div class="px-6 pb-6 sm:px-12 sm:pb-12">
      <h2 class="mb-5 font-medium text-foreground">
        {{ t('pages.autopilot.autopilotsPage.templates.page.subtitle') }}
      </h2>
      <BaseTemplateFilters
        :categories="categories"
        :selectedCategory="selectedCategory"
        @select-category="selectCategory"
      />

      <TransitionGroup name="template-cards" tag="div" class="grid md:grid-cols-3 gap-4">
        <div v-for="template in filteredTemplates" :key="template.id">
          <MarketingFlowTemplate :templates="[template]" />
        </div>
      </TransitionGroup>
    </div>
  </div>
</template>

<style scoped>
.template-cards-enter-active {
  transition: all 0.4s ease-out;
}

.template-cards-leave-active {
  transition: all 0.3s ease-in;
  position: absolute;
}

.template-cards-enter-from {
  opacity: 0;
  transform: translateY(20px) scale(0.95);
}

.template-cards-leave-to {
  opacity: 0;
  transform: translateY(-10px) scale(0.98);
}

.template-cards-move {
  transition: transform 0.4s ease;
}
</style>
